import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ContentAdmin from "./pages/ContentAdmin";
import LegalPage from "./pages/LegalPage";

// Router shell only — the public landing page (route "/") is rendered
// exactly as before via LandingPage.tsx, completely unchanged visually.
// "/content-admin" is an internal maintenance route, not linked from the
// public site's navigation.
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/content-admin" element={<ContentAdmin />} />
        <Route path="/politica-de-privacidad" element={<LegalPage type="privacy" />} />
        <Route path="/terminos-y-condiciones" element={<LegalPage type="terms" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
